import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseApiService } from './base-api.service';
import { environment } from '../../../environments/environment';
import { Activity } from '../models/activity';

@Injectable({
  providedIn: 'root',
})
export class ActivityService extends BaseApiService<Activity> {
  constructor(httpClient: HttpClient) {
    super(httpClient, `${environment.apiUrl}/activities`);
  }

  getActivities() {
    return super.getList();
  }

  getActivity(activityId: string) {
    return this.get(activityId);
  }
}
